import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=8f7c1e12"
import script from "./AccountMenu.vue?vue&type=script&lang=ts"
export * from "./AccountMenu.vue?vue&type=script&lang=ts"
import style0 from "./AccountMenu.vue?vue&type=style&index=0&id=8f7c1e12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports